module.exports = {
      id: "korean-usage",
      viewBox: "0 0 36 24",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#korean-usage",
      toString: function () {
        return this.url;
      }
    }